import { DestinationEvent } from '@eventbrite/event-renderer';
import { $FixMe, SnakeCaseKeysToCamelCase } from '@eventbrite/ts-utils';

export interface PointRadius {
    latitude?: number;
    longitude?: number;
    radius?: string;
    offset?: string;
    scale?: string;
}

export interface SearchCriteriaShape {
    dates?: string[];
    price?: string;
    tags?: string;
}

// These experiment definitions should be removed as experiments conclude
export const SEARCH_EVENT_CARD_MOBILE_SIZE_PARAM =
    'search_event_card_mobile_size';
export enum SEARCH_EVENT_CARD_MOBILE_SIZE_VALUES {
    GRID = 'grid',
    LIST = 'list',
}

export const SEARCH_FILTER_TYPE_PARAM = 'search_filter_type';
export enum SEARCH_FILTER_TYPE_VALUES {
    FILTER_PILLS = 'filter_pills',
    FILTER_PANEL = 'filter_panel',
    MARMALADE_FILTERS = 'marmalade_filters',
    MARMALADE_FILTERS_EXPANDED_HEADER = 'marmalade_filters_expanded_header',
}

export interface SearchServerEnrolledExperiments {
    [SEARCH_EVENT_CARD_MOBILE_SIZE_PARAM]?: SEARCH_EVENT_CARD_MOBILE_SIZE_VALUES;
    [SEARCH_FILTER_TYPE_PARAM]?: SEARCH_FILTER_TYPE_VALUES;
}

export interface ApiSearchData {
    articles: {};
    current_user_id: string;
    profile_search: {};
    article_search: {};
    profiles: {};
    experiment_enrollment: SearchServerEnrolledExperiments;
    events: {
        pagination: {
            object_count: number;
            page_count: number;
            page_number: number;
            page_size: number;
            continuation: string;
        };
        // FIXME: These types are not accurate.
        // The API does not return DestinationEvent
        results: DestinationEvent[];
        aggs: Record<string, object>;
        promoted_results: DestinationEvent[];
        top_match: DestinationEvent[];
    };
    is_staff: boolean;
    search_id: string;
    es: [];
    event_search: ApiEventSearch;
}

export type EventSearch = SnakeCaseKeysToCamelCase<ApiEventSearch>;

export type ApiEventSearch = {
    dates?: any;
    tags?: any;
    price?: string;
    q?: string;
    places?: string[];
    bbox?: string;
    currencies?: any;
    dedup?: boolean;
    dateRange?: any;
    hash?: string;
    languages?: any;
    onlineEventsOnly?: boolean;
    organizationsOr?: string[];
    page?: number;
    pageSize?: number;
    searchId?: string;
    source?: any;
    special?: string[];
    pointRadius?: $FixMe;
    includePromotedEvents?: boolean;
    clientTimezone?: $FixMe;
    durationRange?: $FixMe;
    aggs?: $FixMe;
};

export type PaginationData = {
    page: number;
    pageSize: number;
    pageCount: number;
    objectCount: number;
    continuation: string;
};

export type SearchState = {
    eventSearch: EventSearch;
    gaTrackingData: $FixMe[];
    searchId: string;
};
